(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["liquid-tips"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('liquid-tips')) {
    customElements.define('liquid-tips', class extends HTMLElement {
      connectedCallback() {
        this.control = this.querySelector('[data-refresh-tip]');
        const description = this.querySelector('.highlight-description');
        const tips = Array.from(this.querySelectorAll('[data-tip]'));
        let index = 0;

        this.refreshTip = () => {
          index = (index + 1) % tips.length;
          description.textContent = tips[index].content.textContent.trim();
          description.classList.add('highlight-description--flash');
          description.addEventListener('animationend', () => {
            description.classList.remove('highlight-description--flash');
          }, { once: true });
        };
        this.control.addEventListener('click', this.refreshTip);
      }

      disconnectedCallback() {
        this.control.removeEventListener('click', this.refreshTip);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-ad-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-ad-content')) {
    customElements.define('rw-ad-content', class extends HTMLElement {
      connectedCallback() {
        this.refresh();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.suppress();
        this.bannerElement = null;
      }

      refresh() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.place());
      }

      suppress() {
        this.bannerElement?.setAttribute('data-ad-placement-inactive', '');
        this.bannerElement?.setAttribute('data-ad-empty', 'true');
        if (this.bannerElement) this.bannerElement.hidden = true;
        this.bannerElement?.remove();
        customElements.get('rw-ad-slot')?.queueRefresh();
      }

      place() {
        const content = document.getElementById(this.dataset.contentId)?.querySelector('.rw-prose');
        const template = this.querySelector('template');
        if (!content || content.closest('[hidden]') || !template?.content.firstElementChild) {
          this.suppress();
          return;
        }
        const excluded = 'table, figure, nav, aside, blockquote, ul, ol, dl, details, svg, [hidden], [role="navigation"], [role="img"], [data-toc], .toc, .table-of-contents, .rw-table-frame, .rw-guidance-visual, rw-plan-chart, rw-session-visual, [data-ad-placement], [data-ad-slot-wrapper], [data-ad-content-slot]';
        const eligible = node => !node.closest(excluded) && ['DIV', 'SECTION', 'ARTICLE'].includes(node.parentElement.tagName) && node.textContent.trim();
        let anchor;
        let before = false;
        if (this.dataset.mode === 'before_heading') {
          const headings = [...content.querySelectorAll('h2')].filter(eligible);
          const index = Number(this.dataset.headingIndex || 3);
          if (!Number.isInteger(index) || index < 2) {
            this.suppress();
            return;
          }
          anchor = headings[index - 1];
          before = true;
        } else if (this.dataset.mode === 'after_intro') {
          const firstHeading = [...content.querySelectorAll('h2')].find(eligible);
          anchor = [...content.querySelectorAll('p')].find(eligible);
          if (firstHeading && anchor && !(anchor.compareDocumentPosition(firstHeading) & Node.DOCUMENT_POSITION_FOLLOWING)) {
            this.suppress();
            return;
          }
          let next = anchor?.nextElementSibling;
          while (next) {
            if (next === this.bannerElement) next = next.nextElementSibling;
            if (next?.tagName !== 'P' || !eligible(next)) break;
            anchor = next;
            next = anchor.nextElementSibling;
          }
        } else if (this.dataset.mode === 'after_visual') {
          anchor = content.querySelector(':scope > figure[data-plan-weekly-visual]');
          if (!anchor?.querySelector('rw-plan-chart [data-chart-week]')) anchor = null;
        }
        if (!anchor || anchor.closest('[hidden]')) {
          this.suppress();
          return;
        }
        if (!this.bannerElement) this.bannerElement = template.content.firstElementChild.cloneNode(true);
        this.bannerElement.removeAttribute('data-ad-placement-inactive');
        if (!this.bannerElement.querySelector('rw-ad-slot')) this.bannerElement.hidden = false;
        if (before) {
          if (this.bannerElement.nextElementSibling !== anchor) anchor.before(this.bannerElement);
        } else if (anchor.nextElementSibling !== this.bannerElement) anchor.after(this.bannerElement);
        customElements.get('rw-ad-slot')?.queueRefresh();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-ad-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-ad-grid')) {
    customElements.define('rw-ad-grid', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.dataset.scopeSelector ? this.closest(this.dataset.scopeSelector) : this.parentElement;
        this.afterCard = Number(this.dataset.afterCard);
        if (!this.scope || ![2, 5].includes(this.afterCard)) return;
        if (!this.banner) this.banner = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
        this.refresh();
      }
      disconnectedCallback() {
        this.banner?.setAttribute('data-ad-placement-inactive', '');
        this.banner?.setAttribute('data-ad-empty', 'true');
        if (this.banner) this.banner.hidden = true;
        this.banner?.remove();
        customElements.get('rw-ad-slot')?.queueRefresh();
      }
      refresh() {
        if (!this.banner || !this.scope) return;
        const grids = this.dataset.gridSelector ? Array.from(this.scope.querySelectorAll(this.dataset.gridSelector)) : [this.scope];
        const cards = grids.flatMap(grid => Array.from(grid.children).filter(card => {
          return card !== this.banner && card.matches(this.dataset.cardSelector || 'article') && !card.closest('[hidden]');
        }));
        const anchor = cards[this.afterCard - 1];
        if (!anchor) {
          this.banner.setAttribute('data-ad-placement-inactive', '');
          this.banner.setAttribute('data-ad-empty', 'true');
          this.banner.hidden = true;
          this.banner.remove();
          customElements.get('rw-ad-slot')?.queueRefresh();
          return;
        }
        this.banner.removeAttribute('data-ad-placement-inactive');
        if (!this.banner.querySelector('rw-ad-slot')) this.banner.hidden = false;
        if (anchor.nextElementSibling !== this.banner) anchor.after(this.banner);
        customElements.get('rw-ad-slot')?.queueRefresh();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-ad-slot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-ad-slot')) {
    let scheduledFrame = null;
    const compareHandles = (left, right) => left < right ? -1 : left > right ? 1 : 0;

    class RunningWomanAdSlot extends HTMLElement {
      connectedCallback() {
        RunningWomanAdSlot.queueRefresh();
      }

      disconnectedCallback() {
        RunningWomanAdSlot.queueRefresh();
      }

      static queueRefresh() {
        if (scheduledFrame !== null) return;
        scheduledFrame = requestAnimationFrame(() => {
          scheduledFrame = null;
          RunningWomanAdSlot.allocate();
        });
      }

      static refreshPage() {
        RunningWomanAdSlot.queueRefresh();
      }

      refresh() {
        RunningWomanAdSlot.queueRefresh();
      }

      available() {
        if (!this.isConnected || this.hasAttribute('data-ad-placement-inactive')) return false;
        for (let node = this.parentElement; node; node = node.parentElement) {
          if (node.hasAttribute('data-ad-placement-inactive')) return false;
          const managedHidden = node.hidden && node.hasAttribute('data-ad-slot-wrapper') && node.dataset.adEmpty === 'true';
          if (node.hidden && !managedHidden) return false;
          if (typeof getComputedStyle === 'function') {
            if (managedHidden) node.hidden = false;
            const style = getComputedStyle(node);
            const concealed = style.display === 'none' || style.visibility === 'hidden';
            if (managedHidden) node.hidden = true;
            if (concealed) return false;
          }
        }
        return true;
      }

      candidates() {
        return Array.from(this.children)
          .filter(node => node.tagName === 'TEMPLATE' && node.hasAttribute('data-ad-candidate') && node.content.firstElementChild)
          .map(template => ({
            template,
            handle: template.dataset.adCampaign || '',
            rank: Number(template.dataset.adRank),
            once: template.dataset.adOnce !== 'false',
            fallback: template.hasAttribute('data-ad-fallback'),
          }))
          .filter(candidate => candidate.handle && Number.isFinite(candidate.rank))
          .sort((left, right) => Number(left.fallback) - Number(right.fallback) || right.rank - left.rank || compareHandles(left.handle, right.handle));
      }

      show(candidate) {
        const wrapper = this.closest('[data-ad-slot-wrapper]');
        if (candidate && this.selectedTemplate !== candidate.template) {
          this.selectedElement = candidate.template.content.firstElementChild.cloneNode(true);
          this.append(this.selectedElement);
          this.selectedTemplate = candidate.template;
        }
        this.hidden = !candidate;
        if (wrapper) {
          wrapper.dataset.adEmpty = candidate ? 'false' : 'true';
          wrapper.hidden = !candidate;
        }
      }

      clear() {
        this.selectedElement?.remove();
        this.selectedElement = null;
        this.selectedTemplate = null;
      }

      static allocate() {
        const slots = Array.from(document.querySelectorAll('rw-ad-slot'));
        const claimed = new Set();
        const assignments = slots.map(slot => {
          const candidate = slot.available() ? slot.candidates().find(item => !item.once || !claimed.has(item.handle)) : null;
          if (candidate?.once) claimed.add(candidate.handle);
          return { slot, candidate };
        });
        // Remove all losing assignments before showing replacements, so a move never briefly duplicates artwork.
        for (const { slot, candidate } of assignments) {
          if (slot.selectedTemplate !== candidate?.template) slot.clear();
        }
        for (const { slot, candidate } of assignments) slot.show(candidate);
      }
    }

    customElements.define('rw-ad-slot', RunningWomanAdSlot);
    document.addEventListener('shopify:section:load', RunningWomanAdSlot.queueRefresh);
    document.addEventListener('shopify:section:unload', RunningWomanAdSlot.queueRefresh);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-country-selector')) customElements.define('rw-country-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const details = this.querySelector('details');
      const form = this.querySelector('form');
      const summary = this.querySelector('summary');
      const returnTo = form?.querySelector('input[name="return_to"]');
      const search = this.querySelector('input[type="search"]');
      const searchContainer = this.querySelector('.rw-country-selector__search');
      const list = this.querySelector('.rw-country-selector__list');
      const empty = this.querySelector('.rw-country-selector__empty');
      const options = Array.from(this.querySelectorAll('button[name="country_code"]'));
      if (!details || !form || !summary || !returnTo || !search || !searchContainer || !list || !empty) return;
      this.ready = true;
      searchContainer.hidden = false;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const aliases = { GB: 'uk great britain', US: 'usa america' };
      const labels = options.map(option => normalize(`${option.textContent} ${option.value} ${aliases[option.value] || ''}`));
      const visibleOptions = () => options.filter(option => !option.parentElement.hidden);
      this.onSearch = () => {
        const words = normalize(search.value).split(/\s+/);
        options.forEach((option, index) => { option.parentElement.hidden = !words.every(word => labels[index].includes(word)); });
        empty.hidden = visibleOptions().length > 0;
        list.scrollTop = 0;
      };
      this.updateReturnTo = () => {
        returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      };
      this.onToggle = () => {
        if (!details.open) {
          search.value = '';
          this.onSearch();
          return;
        }
        this.updateReturnTo();
        search.focus({ preventScroll: true });
      };
      this.onKeydown = event => {
        if (!details.open || event.isComposing) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          details.open = false;
          summary.focus();
          return;
        }
        const visible = visibleOptions();
        const index = visible.indexOf(event.target);
        if (event.target === search && event.key === 'Enter') {
          event.preventDefault();
          if (visible.length === 1) visible[0].click();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (event.target !== search && index < 0) return;
          event.preventDefault();
          if (index === 0 && event.key === 'ArrowUp') search.focus();
          else if (event.target === search) (event.key === 'ArrowDown' ? visible[0] : visible.at(-1))?.focus();
          else visible[Math.min(visible.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1))]?.focus();
        } else if (index >= 0 && (event.key === 'Home' || event.key === 'End')) {
          event.preventDefault();
          (event.key === 'Home' ? visible[0] : visible.at(-1))?.focus();
        }
      };
      this.onSubmit = event => {
        // Only an explicitly activated country can submit, never the search field's implicit first button.
        if (!options.includes(event.submitter)) { event.preventDefault(); return; }
        this.updateReturnTo();
      };
      this.onOutsideClick = event => { if (details.open && !this.contains(event.target)) details.open = false; };
      this.onFocusOut = event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false; };
      details.addEventListener('toggle', this.onToggle);
      form.addEventListener('submit', this.onSubmit);
      search.addEventListener('input', this.onSearch);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('click', this.onOutsideClick);
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.querySelector('details').removeEventListener('toggle', this.onToggle);
      this.querySelector('form').removeEventListener('submit', this.onSubmit);
      this.querySelector('input[type="search"]').removeEventListener('input', this.onSearch);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('click', this.onOutsideClick);
      this.ready = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-delivery-currency"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-delivery-currency')) customElements.define('rw-delivery-currency', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const nodes = [...this.querySelectorAll('[data-delivery-money]')];
      const currency = this.dataset.currency;
      const baseCurrency = this.dataset.baseCurrency;
      const source = window.Shopify?.currency;
      const note = this.querySelector('[data-delivery-currency-note]');
      const code = this.querySelector('[data-delivery-currency-code]');
      if (baseCurrency !== 'GBP' || !/^[A-Z]{3}$/.test(currency || '') || !nodes.length) return;
      const rate = currency === 'GBP' ? 1 : Number(source?.rate);
      if (currency !== 'GBP' && source?.active !== currency) return;
      if (!Number.isFinite(rate) || rate <= 0) return;
      // Do not partially convert merchant-written text or infer rates from product prices.
      const amounts = nodes.map(node => {
        const value = node.dataset.deliveryMoney.trim();
        if (value.toLowerCase() === 'free') return 0;
        const match = value.match(/^(?:\u00a3|GBP\s*)(\d+(?:\.\d{1,2})?)$/);
        return match ? Number(match[1]) : NaN;
      });
      if (amounts.some(amount => !Number.isFinite(amount))) return;
      if (amounts.some(amount => !Number.isFinite(amount * rate))) return;
      try {
        const formatter = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency });
        const formatted = amounts.map(amount => amount === 0 ? this.dataset.freeLabel : formatter.format(amount * rate));
        nodes.forEach((node, index) => { node.textContent = formatted[index]; });
        if (code) code.textContent = currency;
        if (note) {
          note.hidden = currency === 'GBP';
          if (currency !== 'GBP') note.textContent = this.dataset.convertedCurrencyNote;
        }
        this.dataset.displayCurrency = currency;
      } catch {
        // A missing formatter leaves explicit GBP amounts readable.
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-external-links"] && !Shopify.designMode) return;
  try {
    class RWExternalLinks extends HTMLElement {
    connectedCallback() {
      const normaliseHost = (host) => host.toLowerCase().replace(/^www\./, '');
      this.internalHosts = new Set(
        [location.hostname, this.dataset.primaryHost, this.dataset.storeHost]
          .filter(Boolean)
          .map(normaliseHost)
      );
      this.normaliseHost = normaliseHost;
      this.originals = this.originals || new WeakMap();
      this.scan(document.body);
      this.observer = new MutationObserver((records) => {
        records.forEach((record) => {
          if (record.type === 'attributes') {
            this.update(record.target);
          } else {
            record.addedNodes.forEach((node) => this.scan(node));
          }
        });
      });
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href']
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    scan(root) {
      if (root.nodeType !== Node.ELEMENT_NODE) return;
      if (root.matches('a[href]')) this.update(root);
      root.querySelectorAll('a[href]').forEach((link) => this.update(link));
    }

    update(link) {
      if (!(link instanceof HTMLAnchorElement)) return;
      let external = false;
      try {
        const url = new URL(link.getAttribute('href'), document.baseURI);
        external = ['http:', 'https:'].includes(url.protocol)
          && !this.internalHosts.has(this.normaliseHost(url.hostname));
      } catch {}

      if (external) {
        if (!this.originals.has(link)) {
          this.originals.set(link, {
            target: link.getAttribute('target'),
            rel: link.getAttribute('rel')
          });
        }
        link.setAttribute('target', '_blank');
        link.relList.remove('opener');
        link.relList.add('noopener', 'noreferrer');
      } else if (this.originals.has(link)) {
        const original = this.originals.get(link);
        ['target', 'rel'].forEach((attribute) => {
          if (original[attribute] === null) link.removeAttribute(attribute);
          else link.setAttribute(attribute, original[attribute]);
        });
        this.originals.delete(link);
      }
    }
  }

  if (!customElements.get('rw-external-links')) {
    customElements.define('rw-external-links', RWExternalLinks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-forms-context"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-forms-context')) {
    customElements.define('rw-forms-context', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.inputs = new WeakSet();
        this.roots = new Map();
        if (!this.validContext()) return;
        this.poll = window.setInterval(() => this.populate(), 500);
        this.populate();
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this.poll !== undefined) window.clearInterval(this.poll);
        this.poll = undefined;
        for (const [root, handlers] of this.roots || []) {
          root.removeEventListener('click', handlers.click, true);
          root.removeEventListener('submit', handlers.submit, true);
        }
        this.roots?.clear();
      }

      validContext() {
        return /^gid:\/\/shopify\/(Product|Article|Page)\/[1-9]\d*$/.test(this.dataset.reviewedItem || '')
          && /^[1-9]\d*$/.test(this.dataset.formId || '')
          && !!this.closest('rw-shopify-reviews');
      }

      eligibleHost(host, scope) {
        if (host.closest('rw-shopify-reviews') !== scope) return false;
        const ancestor = host.closest('[data-forms-id]');
        const ancestorId = ancestor && scope.contains(ancestor) ? ancestor.getAttribute('data-forms-id') : null;
        const hostFormId = host.getAttribute('data-forms-id') || ancestorId;
        return hostFormId === this.dataset.formId || hostFormId === `forms-root-${this.dataset.formId}`;
      }

      populate() {
        if (!this.validContext()) {
          this.dataset.state = 'waiting';
          return;
        }
        if (this.populating) return;
        this.populating = true;
        const value = this.dataset.reviewedItem;
        const scope = this.closest('rw-shopify-reviews');
        let ready = 0;
        let pending = 0;
        const activeRoots = new Set();
        try {
          for (const host of scope.querySelectorAll('shopify-forms-embed')) {
            if (!this.eligibleHost(host, scope)) continue;
            const root = host.shadowRoot;
            if (root) activeRoots.add(root);
            if (root && !this.roots.has(root)) {
              const handlers = {
                click: () => this.populate(),
                submit: event => {
                  this.populate();
                  const current = root.getElementById('custom#reviewed_item');
                  if (!this.validContext() || !this.eligibleHost(host, this.closest('rw-shopify-reviews'))
                    || !(current instanceof HTMLInputElement) || current.value !== this.dataset.reviewedItem) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                  }
                },
              };
              root.addEventListener('click', handlers.click, true);
              root.addEventListener('submit', handlers.submit, true);
              this.roots.set(root, handlers);
            }
            const input = root?.getElementById('custom#reviewed_item');
            if (!(input instanceof HTMLInputElement)) {
              pending += 1;
              continue;
            }
            if (!this.inputs.has(input) || input.value !== value) {
              const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
              setter.call(input, value);
              input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
              if (root.getElementById('custom#reviewed_item') !== input) {
                pending += 1;
                continue;
              }
              input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
            }
            if (input.value !== value || root.getElementById('custom#reviewed_item') !== input) {
              pending += 1;
              continue;
            }
            input.readOnly = true;
            if (this.dataset.hideField === 'true' && input.parentElement) {
              if (!input.parentElement.hidden) input.parentElement.hidden = true;
              if (input.parentElement.style.getPropertyValue('display') !== 'none' || input.parentElement.style.getPropertyPriority('display') !== 'important') {
                input.parentElement.style.setProperty('display', 'none', 'important');
              }
            }
            this.inputs.add(input);
            ready += 1;
          }
          for (const [root, handlers] of this.roots) {
            if (activeRoots.has(root)) continue;
            root.removeEventListener('click', handlers.click, true);
            root.removeEventListener('submit', handlers.submit, true);
            this.roots.delete(root);
          }
          this.dataset.state = ready > 0 && pending === 0 ? 'populated' : 'waiting';
        } finally {
          this.populating = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-forms-publication"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-forms-publication')) customElements.define('rw-forms-publication', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.scope = this.closest('rw-shopify-reviews');
      if (!this.scope || !/^[1-9]\d*$/.test(this.dataset.formId || '')) return;
      this.roots = new Map();
      this.events = new AbortController();
      this.waitAttempts = 0;
      this.scopeObserver = new MutationObserver(() => this.discover());
      this.scopeObserver.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-forms-id'] });
      this.scope.addEventListener('toggle', () => { this.waitAttempts = 0; this.discover(); }, { capture: true, signal: this.events.signal });
      customElements.whenDefined('shopify-forms-embed').then(() => { if (this.isConnected && this.events) this.discover(); });
      this.discover();
    }
    disconnectedCallback() { this.stop(); }
    stop() {
      if (this.waitTimer !== undefined) window.clearInterval(this.waitTimer);
      this.waitTimer = undefined;
      this.events?.abort();
      this.events = null;
      this.scopeObserver?.disconnect();
      for (const [root, state] of this.roots || []) this.release(root, state);
      this.roots?.clear();
    }
    eligibleHost(host) {
      if (host.closest('rw-shopify-reviews') !== this.scope) return false;
      const ancestor = host.closest('[data-forms-id]');
      const ancestorId = ancestor && this.scope.contains(ancestor) ? ancestor.getAttribute('data-forms-id') : null;
      const id = host.getAttribute('data-forms-id') || ancestorId;
      return id === this.dataset.formId || id === `forms-root-${this.dataset.formId}`;
    }
    discover() {
      if (!this.events || !this.isConnected || this.closest('rw-shopify-reviews') !== this.scope) return;
      const active = new Set();
      let waiting = false;
      for (const host of this.scope.querySelectorAll('shopify-forms-embed')) {
        if (!this.eligibleHost(host)) continue;
        const root = host.shadowRoot;
        if (!root) { waiting = true; continue; }
        active.add(root);
        let state = this.roots.get(root);
        if (!state) {
          state = { host, fields: [], changed: new Map(), events: new AbortController() };
          state.observer = new MutationObserver(() => this.enhance(root, state));
          state.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['name', 'id', 'value', 'type', 'disabled', 'checked'] });
          for (const type of ['pointerdown', 'keydown', 'click', 'submit']) root.addEventListener(type, event => this.activate(event, root, state), { capture: true, signal: state.events.signal });
          root.addEventListener('reset', () => queueMicrotask(() => this.enhance(root, state)), { signal: state.events.signal });
          this.roots.set(root, state);
        }
        this.enhance(root, state);
      }
      for (const [root, state] of this.roots) if (!active.has(root)) { this.release(root, state); this.roots.delete(root); }
      if (waiting && this.waitTimer === undefined && this.waitAttempts < 120) {
        this.waitTimer = window.setInterval(() => { this.waitAttempts++; this.discover(); }, 500);
      } else if (!waiting || this.waitAttempts >= 120) {
        if (this.waitTimer !== undefined) window.clearInterval(this.waitTimer);
        this.waitTimer = undefined;
      }
    }
    inspect(root) {
      const forms = root.querySelectorAll('form[data-testid="form"]');
      if (forms.length !== 1) return null;
      const form = forms[0];
      const buttons = form.querySelectorAll('button[type="submit"][data-testid="btn-form-submit"]');
      if (buttons.length !== 1 || buttons[0].parentElement !== form) return null;
      const fields = [], inputs = [];
      for (const [name, value] of [['custom#review_publication', 'review-publication-v1'], ['custom#photo_publication', 'photo-publication-v1']]) {
        const matches = form.querySelectorAll(`fieldset[name="${name}"]`);
        if (matches.length !== 1 || matches[0].closest('form') !== form || matches[0].disabled) return null;
        const children = matches[0].querySelectorAll('input');
        const input = children[0];
        if (children.length !== 1 || !(input instanceof HTMLInputElement) || input.type !== 'checkbox' || input.name !== name || input.value !== value || input.id !== `${name}-${value}` || input.disabled || input.closest('form') !== form) return null;
        fields.push(matches[0]); inputs.push(input);
      }
      return { form, button: buttons[0], fields, inputs };
    }
    enhance(root, state) {
      if (!this.events || state.enhancing) return;
      state.enhancing = true;
      try {
        if (!this.eligibleHost(state.host) || state.host.shadowRoot !== root) { this.restore(state); return; }
        const match = this.inspect(root);
        if (!match) { this.restore(state); return; }
        if (state.form !== match.form || state.button !== match.button || state.fields.some((field, index) => field !== match.fields[index])) this.restore(state);
        Object.assign(state, match);
        if (!state.note?.isConnected) {
          const template = this.querySelector('[data-rw-publication-template]');
          const original = template?.content.querySelector('[data-rw-publication-note]');
          if (!original || !original.textContent.trim()) { this.restore(state); return; }
          state.note = original.cloneNode(true);
          state.note.id = `rw-review-publication-${this.dataset.formId}`;
          state.button.after(state.note);
        }
        if (state.note.parentElement !== match.form || state.button.nextElementSibling !== state.note) state.button.after(state.note);
        if (!state.style?.isConnected) {
          const style = this.querySelector('[data-rw-publication-style]')?.content.querySelector('style');
          if (!style) { this.restore(state); return; }
          state.style = style.cloneNode(true); root.append(state.style);
        }
        if (state.description === undefined) state.description = state.button.getAttribute('aria-describedby');
        const description = [...new Set([...(state.description || '').split(/\s+/).filter(Boolean), state.note.id])].join(' ');
        if (state.button.getAttribute('aria-describedby') !== description) state.button.setAttribute('aria-describedby', description);
        for (const field of state.fields) if (!field.hasAttribute('data-rw-publication-field')) field.setAttribute('data-rw-publication-field', '');
      } finally { state.enhancing = false; }
    }
    activate(event, root, state) {
      const match = this.inspect(root);
      if (!match || !state.note?.isConnected || match.button.disabled || match.button.getAttribute('aria-disabled') === 'true') return;
      const target = event.target;
      let submission = event.type === 'submit' && target === match.form;
      if (event.type === 'pointerdown' || event.type === 'click') submission = event.button === 0 && target?.closest('button') === match.button;
      if (event.type === 'keydown' && !event.isComposing) {
        const buttonKey = target === match.button && ['Enter', ' ', 'Spacebar'].includes(event.key);
        const implicitKey = event.key === 'Enter' && target instanceof HTMLInputElement && !['file', 'checkbox', 'radio', 'button', 'reset', 'submit'].includes(target.type) && target.closest('form') === match.form;
        submission = buttonKey || implicitKey;
      }
      if (submission) this.acknowledge(root, state);
    }
    acknowledge(root, state) {
      this.enhance(root, state);
      let match = this.inspect(root);
      if (!this.events || !this.eligibleHost(state.host) || state.host.shadowRoot !== root || !match || !state.note?.isConnected || state.note.parentElement !== match.form || match.button.nextElementSibling !== state.note) return false;
      // Native clicks notify Shopify Forms' controlled state before its submit handler.
      for (let index = 0; index < 2; index++) {
        const input = match.inputs[index];
        if (!input.checked) { state.changed.set(input, false); input.click(); }
        const current = this.inspect(root);
        if (!current || current.inputs[index] !== input || !input.checked) { this.restore(state); return false; }
        match = current;
      }
      return true;
    }
    restore(state) {
      for (const field of state.fields || []) field.removeAttribute('data-rw-publication-field');
      if (state.button && state.description !== undefined) {
        if (state.description === null) state.button.removeAttribute('aria-describedby');
        else state.button.setAttribute('aria-describedby', state.description);
      }
      state.note?.remove(); state.style?.remove();
      for (const [input, original] of state.changed || []) if (input.isConnected && input.checked !== original) input.click();
      state.changed?.clear();
      state.form = null; state.button = null; state.fields = []; state.inputs = [];
      state.note = null; state.style = null; state.description = undefined;
    }
    release(root, state) { state.observer.disconnect(); state.events.abort(); this.restore(state); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-forms-stars"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-forms-stars')) customElements.define('rw-forms-stars', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.scope = this.closest('rw-shopify-reviews');
      if (!this.scope || !/^[1-9]\d*$/.test(this.dataset.formId || '')) return;
      this.waitAttempts = 0;
      this.roots = new Map();
      this.events = new AbortController();
      this.scopeObserver = new MutationObserver(() => this.discover());
      this.scopeObserver.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-forms-id'] });
      this.scope.addEventListener('toggle', () => { this.waitAttempts = 0; this.discover(); }, { capture: true, signal: this.events.signal });
      customElements.whenDefined('shopify-forms-embed').then(() => { if (this.isConnected && this.events) this.discover(); });
      this.discover();
    }
    disconnectedCallback() { this.stop(); }
    stop() {
      if (this.waitTimer !== undefined) window.clearInterval(this.waitTimer);
      this.waitTimer = undefined;
      this.events?.abort();
      this.events = null;
      this.scopeObserver?.disconnect();
      this.scopeObserver = null;
      for (const [root, state] of this.roots || []) this.release(root, state);
      this.roots?.clear();
    }
    eligibleHost(host) {
      if (host.closest('rw-shopify-reviews') !== this.scope) return false;
      const ancestor = host.closest('[data-forms-id]');
      const ancestorId = ancestor && this.scope.contains(ancestor) ? ancestor.getAttribute('data-forms-id') : null;
      const id = host.getAttribute('data-forms-id') || ancestorId;
      return id === this.dataset.formId || id === `forms-root-${this.dataset.formId}`;
    }
    discover() {
      if (!this.events || !this.isConnected || this.closest('rw-shopify-reviews') !== this.scope) return;
      const active = new Set();
      let waiting = false;
      for (const host of this.scope.querySelectorAll('shopify-forms-embed')) {
        if (!this.eligibleHost(host)) continue;
        const root = host.shadowRoot;
        if (!root) { waiting = true; continue; }
        active.add(root);
        let state = this.roots.get(root);
        if (!state) {
          state = { host, field: null, options: null, inputs: [], labels: [], originalLabels: new Map(), events: new AbortController() };
          state.observer = new MutationObserver(() => this.enhance(root, state));
          state.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value', 'name', 'id', 'for', 'aria-label'] });
          const synchronize = () => this.enhance(root, state);
          root.addEventListener('change', synchronize, { signal: state.events.signal });
          root.addEventListener('input', synchronize, { signal: state.events.signal });
          root.addEventListener('reset', () => queueMicrotask(synchronize), { signal: state.events.signal });
          this.roots.set(root, state);
        }
        this.enhance(root, state);
      }
      for (const [root, state] of this.roots) {
        if (active.has(root)) continue;
        this.release(root, state);
        this.roots.delete(root);
      }
      if (waiting && this.waitTimer === undefined && (this.waitAttempts || 0) < 120) {
        this.waitTimer = window.setInterval(() => {
          this.waitAttempts = (this.waitAttempts || 0) + 1;
          this.discover();
        }, 500);
      } else if (!waiting || (this.waitAttempts || 0) >= 120) {
        if (this.waitTimer !== undefined) window.clearInterval(this.waitTimer);
        this.waitTimer = undefined;
      }
    }
    inspect(root) {
      const fields = root.querySelectorAll('fieldset[name="custom#rating"]');
      if (fields.length !== 1) return null;
      const field = fields[0];
      const inputs = [...field.querySelectorAll('input')];
      if (inputs.length !== 5 || inputs.some(input => !(input instanceof HTMLInputElement) || input.type !== 'radio' || input.name !== 'custom#rating')) return null;
      if (new Set(inputs.map(input => input.value)).size !== 5 || inputs.some(input => !/^[1-5]$/.test(input.value))) return null;
      if (inputs.filter(input => input.checked).length > 1) return null;
      const ordered = [...inputs].sort((left, right) => Number(left.value) - Number(right.value));
      if (inputs.some((input, index) => input !== ordered[index])) return null;
      const labels = inputs.map(input => input.closest('label'));
      if (new Set(labels).size !== 5 || labels.some((label, index) => !label || !field.contains(label) || label.htmlFor !== inputs[index].id || inputs[index].id !== `custom#rating-${index + 1}`)) return null;
      const options = labels[0].parentElement;
      if (!options || options.parentElement !== field || labels.some(label => label.parentElement !== options)) return null;
      return { field, options, inputs, labels };
    }
    enhance(root, state) {
      if (!this.events) return;
      if (!this.eligibleHost(state.host) || state.host.shadowRoot !== root) { this.restore(state); return; }
      const match = this.inspect(root);
      if (!match) { this.restore(state); return; }
      if (state.field !== match.field || state.inputs.some((input, index) => input !== match.inputs[index])) this.restore(state);
      Object.assign(state, match);
      if (!state.style?.isConnected) {
        const template = this.querySelector('[data-rw-stars-style]');
        const stylesheet = template?.content.querySelector('style');
        if (!stylesheet) return;
        state.style = stylesheet.cloneNode(true);
        state.style.setAttribute('data-rw-stars-style', '');
        root.append(state.style);
      }
      if (!state.field.hasAttribute('data-rw-stars')) state.field.setAttribute('data-rw-stars', '');
      if (!state.options.hasAttribute('data-rw-star-options')) state.options.setAttribute('data-rw-star-options', '');
      const selected = state.inputs.find(input => input.checked)?.value || '0';
      for (let index = 0; index < 5; index++) {
        const input = state.inputs[index];
        const label = state.labels[index];
        if (!state.originalLabels.has(input)) state.originalLabels.set(input, input.getAttribute('aria-label'));
        const accessible = (this.dataset.ratingLabel || '[rating] out of 5 stars').replaceAll('[rating]', input.value);
        if (input.getAttribute('aria-label') !== accessible) input.setAttribute('aria-label', accessible);
        if (label.getAttribute('data-rw-star-value') !== input.value) label.setAttribute('data-rw-star-value', input.value);
        const filled = String(Number(input.value) <= Number(selected));
        if (label.getAttribute('data-rw-star-filled') !== filled) label.setAttribute('data-rw-star-filled', filled);
      }
    }
    restore(state) {
      state.field?.removeAttribute('data-rw-stars');
      state.options?.removeAttribute('data-rw-star-options');
      for (const label of state.labels) {
        label.removeAttribute('data-rw-star-value');
        label.removeAttribute('data-rw-star-filled');
      }
      for (const [input, value] of state.originalLabels) {
        if (value === null) input.removeAttribute('aria-label');
        else if (input.getAttribute('aria-label') !== value) input.setAttribute('aria-label', value);
      }
      state.originalLabels.clear();
      state.field = null; state.options = null; state.inputs = []; state.labels = [];
    }
    release(root, state) {
      state.observer.disconnect();
      state.events.abort();
      this.restore(state);
      state.style?.remove();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-pace-engine"] && !Shopify.designMode) return;
  try {
    const RunningWomanPace = Object.freeze({
    mile: 1.609344,
    races: Object.freeze({
      five_k: 5,
      five_miles: 5 * 1.609344,
      ten_k: 10,
      ten_miles: 10 * 1.609344,
      half: 21.0975,
      marathon: 42.195
    }),
    calculate(mode, distance, unit, time, pace, paceUnit, options = {}) {
      if (!['pace', 'speed', 'time', 'distance'].includes(mode)) throw new RangeError('Unknown calculation mode');
      if (!['km', 'mile'].includes(unit) || !['km', 'mile'].includes(paceUnit)) throw new RangeError('Unknown distance unit');
      const km = distance * (unit === 'mile' ? this.mile : 1);
      let result;
      if (mode === 'pace' || mode === 'speed') result = { km, time, pace: time / km };
      else {
        const inputKind = options.inputKind === undefined ? 'pace' : options.inputKind;
        if (!['pace', 'speed'].includes(inputKind)) throw new RangeError('Unknown calculation input');
        const perKm = inputKind === 'speed'
          ? this.speedToPace(options.speed, options.speedUnit)
          : pace / (paceUnit === 'mile' ? this.mile : 1);
        if (mode === 'time') result = { km, time: km * perKm, pace: perKm };
        else result = { km: time / perKm, time, pace: perKm };
      }
      if (!Object.values(result).every(value => Number.isFinite(value) && value > 0)) throw new RangeError('Positive finite values required');
      return result;
    },
    speedToPace(speed, unit = 'kmh') {
      if (!['kmh', 'mph'].includes(unit)) throw new RangeError('Unknown speed unit');
      if (!Number.isFinite(speed) || speed <= 0) throw new RangeError('Positive finite speed required');
      const perKm = 3600 / (speed * (unit === 'mph' ? this.mile : 1));
      if (!Number.isFinite(perKm) || perKm <= 0) throw new RangeError('Speed exceeds the supported range');
      return perKm;
    },
    roundSpeed(speed) {
      if (!Number.isFinite(speed) || speed < 0) throw new RangeError('Non-negative finite speed required');
      return this.roundSeconds(speed * 10) / 10;
    },
    tableTarget(perKm, familyUnit) {
      if (!Number.isFinite(perKm) || perKm <= 0) return null;
      if (familyUnit === 'km' || familyUnit === 'mile') {
        const seconds = perKm * (familyUnit === 'mile' ? this.mile : 1);
        if (!Number.isFinite(seconds) || seconds > 3660) return null;
        const minutes = Math.floor(this.roundSeconds(seconds) / 60);
        return minutes >= 1 && minutes <= 60 ? `${minutes}:${familyUnit}` : null;
      }
      if (familyUnit === 'kmh' || familyUnit === 'mph') {
        const minimum = familyUnit === 'kmh' ? 3 : 2;
        const maximum = familyUnit === 'kmh' ? 20 : 13;
        const speed = 3600 / perKm / (familyUnit === 'mph' ? this.mile : 1);
        if (!Number.isFinite(speed) || speed > maximum + 1) return null;
        const base = Math.floor(this.roundSpeed(speed));
        return base >= minimum && base <= maximum ? `${base}:${familyUnit}` : null;
      }
      return null;
    },
    clock(seconds) {
      const total = this.roundSeconds(seconds);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor(total / 60) % 60;
      const secs = String(total % 60).padStart(2, '0');
      return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${secs}` : `${minutes}:${secs}`;
    },
    paceClock(seconds) {
      const total = this.roundSeconds(seconds);
      return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
    },
    roundSeconds(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) throw new RangeError('Non-negative finite seconds required');
      const total = Math.round(seconds + 1e-8);
      if (!Number.isSafeInteger(total)) throw new RangeError('Seconds exceed the supported range');
      return total;
    },
    row(perKm) {
      if (!Number.isFinite(perKm) || perKm <= 0) throw new RangeError('Positive finite pace required');
      const kmh = 3600 / perKm;
      return {
        pace: perKm,
        perKm,
        perMile: perKm * this.mile,
        kmh,
        mph: kmh / this.mile,
        times: Object.fromEntries(Object.entries(this.races).map(([race, km]) => [race, km * perKm]))
      };
    },
    paceRows(minutes, unit) {
      if (!Number.isInteger(minutes) || minutes < 1 || minutes > 60) throw new RangeError('Pace minutes must be an integer from 1 to 60');
      if (!['km', 'mile'].includes(unit)) throw new RangeError('Unknown pace unit');
      return Array.from({ length: 60 }, (_, second) => {
        const seconds = minutes * 60 + second;
        return { seconds, ...this.row(seconds / (unit === 'mile' ? this.mile : 1)) };
      });
    },
    treadmillRows(speed, unit = 'kmh') {
      if (!Number.isInteger(speed) || speed < 1 || speed > 40) throw new RangeError('Treadmill base speed must be an integer from 1 to 40');
      if (!['kmh', 'mph'].includes(unit)) throw new RangeError('Unknown speed unit');
      return Array.from({ length: 10 }, (_, tenth) => {
        const selectedSpeed = (speed * 10 + tenth) / 10;
        const kmh = selectedSpeed * (unit === 'mph' ? this.mile : 1);
        return { speed: selectedSpeed, ...this.row(3600 / kmh) };
      });
    }
  });
  if (!customElements.get('rw-pace-engine')) customElements.define('rw-pace-engine', class extends HTMLElement {
    static get math() { return RunningWomanPace; }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-pace-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-pace-links')) customElements.define('rw-pace-links', class extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.groups = [...this.querySelectorAll('[data-pace-link-unit]')];
        this.tabs = [...this.querySelectorAll('[data-pace-link-tab]')];
        this.heading = this.querySelector('[data-pace-link-heading]');
        this.navigation = this.querySelector('nav');
        this.tablist = this.querySelector('[data-pace-link-tabs]');
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            if (!tab.hidden) this.selectUnit(tab.dataset.paceLinkTab);
          });
          tab.addEventListener('keydown', event => {
            if (tab.hidden) return;
            const tabs = this.tabs.filter(item => !item.hidden);
            const index = tabs.indexOf(tab);
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) {
              event.preventDefault();
              this.selectUnit(tabs[next].dataset.paceLinkTab);
              tabs[next].focus();
            }
          });
        });
        this.onUnit = event => this.selectUnit(event.detail?.unit);
        this.ready = true;
      }
      this.source = document.getElementById(this.dataset.source);
      this.source?.addEventListener('rw:pace-unit', this.onUnit);
      const unit = this.source?.dataset.paceLinkUnit || this.dataset.unit;
      if (!this.selectUnit(unit)) this.selectUnit(this.groups[0]?.dataset.paceLinkUnit);
    }

    disconnectedCallback() { this.source?.removeEventListener('rw:pace-unit', this.onUnit); }

    selectUnit(unit) {
      if (!['mile', 'km', 'kmh', 'mph'].includes(unit)) return false;
      const family = ['kmh', 'mph'].includes(unit) ? ['kmh', 'mph'] : ['km', 'mile'];
      const selected = this.groups.find(group => group.dataset.paceLinkUnit === unit)
        || this.groups.find(group => family.includes(group.dataset.paceLinkUnit))
        || this.groups[0];
      const selectedUnit = selected?.dataset.paceLinkUnit;
      const speed = ['kmh', 'mph'].includes(selectedUnit);
      const enhanced = this.groups.length > 1;
      this.dataset.unit = selectedUnit || unit;
      this.heading.textContent = speed ? this.dataset.speedHeading : this.dataset.paceHeading;
      this.tablist.setAttribute('aria-label', this.dataset.unitsLabel || `${this.dataset.paceUnitLabel} / ${this.dataset.speedUnitLabel}`);
      this.navigation.hidden = !selected;
      this.tablist.hidden = !enhanced;
      if (enhanced) this.classList.add('is-enhanced');
      else this.classList.remove('is-enhanced');
      this.tabs.forEach(tab => {
        const active = tab.dataset.paceLinkTab === selectedUnit;
        tab.hidden = !this.groups.some(group => group.dataset.paceLinkUnit === tab.dataset.paceLinkTab);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.groups.forEach(group => {
        group.hidden = group !== selected;
        if (enhanced) {
          const tab = this.tabs.find(item => item.dataset.paceLinkTab === group.dataset.paceLinkUnit);
          group.setAttribute('role', 'tabpanel');
          group.setAttribute('aria-labelledby', tab.id);
        } else {
          group.removeAttribute('role');
          group.removeAttribute('aria-labelledby');
        }
      });
      return true;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-pace-tool"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-pace-tables')) customElements.define('rw-pace-tables', class extends HTMLElement {
    static selection(search, defaults) {
      const params = new URLSearchParams(search);
      if (!['mode', 'pace', 'speed', 'unit'].some(key => params.has(key))) return { state: { ...defaults }, invalid: false };
      const mode = params.get('mode') || (params.has('speed') ? 'treadmill' : 'pace');
      const value = params.get(mode === 'treadmill' ? 'speed' : 'pace');
      const amount = value === null ? (mode === 'treadmill' ? defaults.speed : defaults.minutes) : Number(value);
      const unit = params.get('unit') || (mode === 'treadmill' ? defaults.speedUnit : defaults.unit);
      const valid = Number.isInteger(amount) && amount >= 1 && amount <= (mode === 'treadmill' ? 40 : 60);
      if (!['pace', 'treadmill'].includes(mode) || !valid || !(mode === 'treadmill' ? ['kmh', 'mph'] : ['km', 'mile']).includes(unit)) return { state: { ...defaults }, invalid: true };
      return { state: mode === 'treadmill' ? { ...defaults, mode, speed: amount, speedUnit: unit } : { ...defaults, mode, minutes: amount, unit }, invalid: false };
    }

    static destination(state, hub, routes, current) {
      const currentUrl = new URL(current);
      const key = state.mode === 'treadmill' ? `${state.speed}:${state.speedUnit}` : `${state.minutes}:${state.unit}`;
      const native = routes[key];
      const url = new URL(native || hub, currentUrl);
      for (const key of ['preview_theme_id', '_ab', '_fd', '_sc']) {
        if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
      }
      if (!native) {
        url.searchParams.set('mode', state.mode);
        url.searchParams.set(state.mode === 'pace' ? 'pace' : 'speed', state.mode === 'pace' ? state.minutes : state.speed);
        url.searchParams.set('unit', state.mode === 'pace' ? state.unit : state.speedUnit);
      }
      return { url, native: Boolean(native) };
    }

    static nativeDestination(amount, unit, routes, current) {
      const limits = { km: [4, 20], mile: [4, 20], kmh: [3, 20], mph: [2, 13] };
      const bounds = limits[unit];
      const raw = String(amount).trim();
      const value = Number(raw);
      if (!bounds || !/^\d+$/.test(raw) || !Number.isInteger(value) || value < bounds[0] || value > bounds[1] || !routes[`${value}:${unit}`]) return null;
      const speed = unit === 'kmh' || unit === 'mph';
      const state = speed ? { mode: 'treadmill', speed: value, speedUnit: unit } : { mode: 'pace', minutes: value, unit };
      return this.destination(state, current, routes, current).url;
    }

    connectNative() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-native-table-form]');
      this.routes = JSON.parse(this.querySelector('[data-pace-routes]').textContent);
      const families = JSON.parse(this.querySelector('[data-native-families]').textContent);
      const range = this.form.elements.table_range;
      const unit = this.form.elements.table_unit;
      const error = this.querySelector('[data-pace-error]');
      const configure = () => {
        const family = families[unit.value];
        if (!family) return;
        range.min = family.minimum;
        range.max = family.maximum;
        this.querySelector('[data-native-range-label]').textContent = family.label;
        error.hidden = true;
      };
      unit.addEventListener('change', configure);
      range.addEventListener('input', () => { error.hidden = true; });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        const target = this.constructor.nativeDestination(range.value, unit.value, this.routes, location.href);
        if (target) location.assign(target.href);
        else error.hidden = false;
      });
      configure();
      this.form.hidden = false;
    }

    async connectedCallback() {
      if (this.dataset.pageSpecific === 'true') { this.connectNative(); return; }
      if (this.ready) { window.addEventListener('popstate', this.onHistory); return; }
      await customElements.whenDefined('rw-pace-engine');
      if (!this.isConnected || this.ready) return;
      this.ready = true;
      this.math = customElements.get('rw-pace-engine').math;
      this.labels = JSON.parse(this.querySelector('[data-pace-labels]').textContent);
      this.routes = JSON.parse(this.querySelector('[data-pace-routes]').textContent);
      this.form = this.querySelector('form');
      this.defaults = { mode: this.dataset.mode, minutes: Number(this.dataset.minutes), unit: this.dataset.unit, speed: Number(this.dataset.speed), speedUnit: this.dataset.speedUnit };
      this.state = { ...this.defaults };
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.state.mode = tab.dataset.mode;
          this.configure();
          this.draw();
          this.changeUrl();
        });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.tabs[next].click(); this.tabs[next].focus(); }
        });
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        const state = { ...this.state, minutes: Number(this.form.elements.minutes.value), unit: this.form.elements.pace_unit.value, speed: Number(this.form.elements.speed.value), speedUnit: this.form.elements.speed_unit.value };
        try {
          if (state.mode === 'pace') this.math.paceRows(state.minutes, state.unit);
          else this.math.treadmillRows(state.speed, state.speedUnit);
          this.state = state;
          const target = this.constructor.destination(state, this.dataset.hub, this.routes, location.href);
          if (target.native && target.url.pathname !== location.pathname && !window.Shopify?.designMode) {
            location.assign(target.url.href);
            return;
          }
          this.draw();
          this.changeUrl();
        } catch { this.showError(); }
      });
      this.onHistory = () => this.restore();
      window.addEventListener('popstate', this.onHistory);
      this.restore();
    }

    disconnectedCallback() { window.removeEventListener('popstate', this.onHistory); }

    restore() {
      let defaults = this.defaults;
      const nativeRoute = Object.entries(this.routes).find(([, path]) => new URL(path, location.href).pathname === location.pathname);
      if (nativeRoute) {
        const [amount, unit] = nativeRoute[0].split(':');
        defaults = ['kmh', 'mph'].includes(unit)
          ? { ...defaults, mode: 'treadmill', speed: Number(amount), speedUnit: unit }
          : { ...defaults, mode: 'pace', minutes: Number(amount), unit };
      }
      const selected = this.constructor.selection(location.search, defaults);
      this.state = selected.state;
      this.configure();
      this.draw();
      if (selected.invalid) this.showError();
    }

    configure() {
      this.tabs.forEach(tab => {
        const active = tab.dataset.mode === this.state.mode;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active) this.querySelector('[role="tabpanel"]').setAttribute('aria-labelledby', tab.id);
      });
      this.querySelectorAll('[data-fields]').forEach(fields => { fields.hidden = fields.dataset.fields !== this.state.mode; fields.disabled = fields.hidden; });
      this.form.elements.minutes.value = this.state.minutes;
      this.form.elements.pace_unit.value = this.state.unit;
      this.form.elements.speed.value = this.state.speed;
      this.form.elements.speed_unit.value = this.state.speedUnit;
    }

    text(key, values) { return Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`[${name}]`, value), this.labels[key]); }

    draw() {
      const treadmill = this.state.mode === 'treadmill';
      const rows = treadmill ? this.math.treadmillRows(this.state.speed, this.state.speedUnit) : this.math.paceRows(this.state.minutes, this.state.unit);
      const speedUnit = this.labels[this.state.speedUnit];
      const paceUnit = this.labels[this.state.unit === 'mile' ? 'min_mile' : 'min_km'];
      const values = treadmill ? { start: this.state.speed.toFixed(1), end: (this.state.speed + .9).toFixed(1), unit: speedUnit } : { minutes: this.state.minutes, start: `${this.state.minutes}:00`, end: `${this.state.minutes}:59`, unit: this.labels[this.state.unit] };
      const title = this.text(treadmill ? 'treadmill_title' : 'pace_title', values);
      const intro = this.text(treadmill ? 'treadmill_intro' : 'pace_intro', { ...values, unit: treadmill ? speedUnit : paceUnit });
      this.querySelector('[data-pace-heading]').textContent = title;
      this.querySelector('[data-pace-intro]').textContent = intro;
      this.querySelector('.rw-pace-note').textContent = this.labels[treadmill ? 'treadmill_constant' : 'constant'];
      const table = this.querySelector('table');
      table.caption.textContent = title;
      const headers = treadmill ? [speedUnit, this.labels[this.state.speedUnit === 'mph' ? 'kmh' : 'mph'], this.labels.min_km, this.labels.min_mile] : [paceUnit, this.labels[this.state.unit === 'mile' ? 'min_km' : 'min_mile']];
      const races = Object.keys(this.math.races);
      headers.push(...races.map(key => this.labels.races[key]));
      const heading = document.createElement('tr');
      headers.forEach((text, index) => { const cell = document.createElement('th'); cell.scope = 'col'; cell.textContent = text; if (index === 0) cell.dataset.stickyPace = ''; heading.append(cell); });
      table.tHead.replaceChildren(heading);
      const body = document.createDocumentFragment();
      rows.forEach(row => {
        const tr = document.createElement('tr');
        const values = treadmill ? [row[this.state.speedUnit].toFixed(1), row[this.state.speedUnit === 'mph' ? 'kmh' : 'mph'].toFixed(2), this.math.paceClock(row.perKm), this.math.paceClock(row.perMile)] : [this.math.paceClock(row.seconds), this.math.paceClock(this.state.unit === 'mile' ? row.perKm : row.perMile)];
        values.push(...races.map(key => this.math.clock(row.times[key])));
        values.forEach((text, index) => { const cell = document.createElement(index === 0 ? 'th' : 'td'); cell.textContent = text; if (index === 0) { cell.scope = 'row'; cell.dataset.stickyPace = ''; } tr.append(cell); });
        body.append(tr);
      });
      table.tBodies[0].replaceChildren(body);
      const scroll = table.closest('.rw-table-scroll');
      if (scroll) { scroll.setAttribute('aria-label', title); scroll.scrollTo({ left: 0, top: 0 }); }
      this.querySelector('[data-pace-error]').hidden = true;
      this.querySelector('[data-pace-status]').textContent = this.text('status', { count: rows.length, title });
      this.dataset.paceLinkUnit = treadmill ? this.state.speedUnit : this.state.unit;
      this.dispatchEvent(new CustomEvent('rw:pace-unit', { detail: { unit: this.dataset.paceLinkUnit } }));
      this.metadata(title, intro);
    }

    showError() { const error = this.querySelector('[data-pace-error]'); error.textContent = this.labels.error; error.hidden = false; }

    changeUrl() {
      if (window.Shopify?.designMode) return;
      const target = this.constructor.destination(this.state, this.dataset.hub, this.routes, location.href);
      if (target.url.href !== location.href) history.pushState(null, '', target.url.href);
      this.canonical(target.url);
    }

    metadata(title, description) {
      const sameSelection = this.state.mode === this.defaults.mode && (this.state.mode === 'treadmill'
        ? this.state.speed === this.defaults.speed && this.state.speedUnit === this.defaults.speedUnit
        : this.state.minutes === this.defaults.minutes && this.state.unit === this.defaults.unit);
      const initialNative = this.dataset.pageSpecific === 'true' && sameSelection;
      const metadataTitle = initialNative && this.dataset.nativeTitle ? this.dataset.nativeTitle : title;
      document.title = metadataTitle.includes(this.dataset.brand) ? metadataTitle : `${metadataTitle} | ${this.dataset.brand}`;
      const metadataDescription = initialNative && this.dataset.nativeDescription ? this.dataset.nativeDescription : description;
      for (const selector of ['meta[name="description"]', 'meta[property="og:description"]', 'meta[name="twitter:description"]']) {
        let meta = document.querySelector(selector);
        if (!meta && selector === 'meta[name="description"]') { meta = document.createElement('meta'); meta.name = 'description'; document.head.append(meta); }
        if (meta) meta.content = metadataDescription;
      }
      for (const selector of ['meta[property="og:title"]', 'meta[name="twitter:title"]']) { const meta = document.querySelector(selector); if (meta) meta.content = metadataTitle; }
      this.canonical(this.constructor.destination(this.state, this.dataset.hub, this.routes, location.href).url);
    }

    canonical(url) {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) return;
      const target = new URL(url.pathname, new URL(canonical.href).origin);
      canonical.href = target.href;
      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.content = target.href;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-plan-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-plan-chart')) {
    customElements.define('rw-plan-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.weeks = Array.from(this.querySelectorAll('[data-chart-week]'));
        this.detail = this.querySelector('[data-chart-detail]');
        this.weeks.forEach((week, index) => {
          week.setAttribute('role', 'button');
          week.setAttribute('tabindex', index === 0 ? '0' : '-1');
          week.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.show(week); });
          week.addEventListener('pointerleave', () => { if (!this.pinned && !this.contains(document.activeElement)) this.hide(); });
          week.addEventListener('focus', () => this.show(week));
          week.addEventListener('click', () => { this.pinned = true; this.select(index); });
          week.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = Math.min(index + 1, this.weeks.length - 1);
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = Math.max(index - 1, 0);
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.weeks.length - 1;
            else if (event.key === 'Escape') { event.preventDefault(); this.hide(); return; }
            else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.pinned = true; this.show(week); return; }
            else return;
            event.preventDefault();
            this.select(next);
          });
        });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.hide(); });
        this.addEventListener('pointerleave', () => { if (!this.pinned && !this.contains(document.activeElement)) this.hide(); });
      }
      select(index) {
        this.weeks.forEach((week, i) => week.setAttribute('tabindex', i === index ? '0' : '-1'));
        this.weeks[index].focus({ preventScroll: true });
        this.show(this.weeks[index]);
      }
      show(week) { this.detail.textContent = week.getAttribute('aria-label'); this.detail.hidden = false; }
      hide() { this.pinned = false; this.detail.hidden = true; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-policy-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-policy-page')) {
    customElements.define('rw-policy-page', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
      }

      initialize() {
        if (this.dataset.initialized) return;
        const content = this.querySelector('.rw-policy-copy, .shopify-policy__body .rte');
        if (!content) return;
        this.dataset.initialized = 'true';
        const directory = this.querySelector('.rw-policy-directory');
        const contents = this.querySelector('.rw-policy-contents');
        const mobile = matchMedia('(max-width: 800px)').matches;
        directory.open = !mobile;
        let headings = [...content.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
        if (!headings.length) {
          headings = [...content.querySelectorAll('h3')].filter(heading => heading.textContent.trim());
          this.dataset.headingLevel = 'h3';
        }
        if (headings.length < 4) return;
        const navigation = contents.querySelector('nav');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            const base = this.id + '-heading-' + (index + 1);
            let id = base;
            let suffix = 1;
            while (document.getElementById(id)) id = base + '-' + suffix++;
            heading.id = id;
          }
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          link.addEventListener('click', () => {
            if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
            heading.focus({ preventScroll: true });
          });
          navigation.append(link);
        });
        contents.open = !mobile;
        contents.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-product-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-product-carousel')) {
    class RunningWomanProductCarousel extends HTMLElement {
      connectedCallback() {
        if (this.track) return;
        const track = this.querySelector('[data-product-carousel-track]');
        const previous = this.querySelector('[data-product-carousel-previous]');
        const next = this.querySelector('[data-product-carousel-next]');
        if (!track || !previous || !next) return;
        this.track = track;
        this.previous = previous;
        this.next = next;
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onUpdate = () => this.update();
        this.onKeydown = event => {
          if (event.target !== this.track || !this.hasOverflow()) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.move(rtl ? -direction : direction);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.moveToEdge(event.key === 'End');
          }
        };
        previous.addEventListener('click', this.onPrevious);
        next.addEventListener('click', this.onNext);
        track.addEventListener('scroll', this.onUpdate, { passive: true });
        track.addEventListener('keydown', this.onKeydown);
        window.addEventListener('resize', this.onUpdate);
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.onUpdate);
          this.resizeObserver.observe(track);
        }
        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(this.onUpdate);
          this.mutationObserver.observe(track, { childList: true });
        }
        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.previous.removeEventListener('click', this.onPrevious);
        this.next.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.onUpdate);
        this.track.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('resize', this.onUpdate);
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.resizeObserver = null;
        this.mutationObserver = null;
        this.track = null;
        this.previous = null;
        this.next = null;
      }

      hasOverflow() {
        return this.track.scrollWidth > this.track.clientWidth + 1;
      }

      bounds() {
        const style = getComputedStyle(this.track);
        const rect = this.track.getBoundingClientRect();
        return {
          left: rect.left + (parseFloat(style.paddingLeft) || 0),
          right: rect.right - (parseFloat(style.paddingRight) || 0),
          rtl: style.direction === 'rtl'
        };
      }

      update() {
        if (!this.track) return;
        const overflow = this.hasOverflow();
        const first = this.track.firstElementChild;
        const last = this.track.lastElementChild;
        this.previous.hidden = !overflow;
        this.next.hidden = !overflow;
        if (!overflow || !first || !last) {
          this.previous.disabled = true;
          this.next.disabled = true;
          return;
        }
        const bounds = this.bounds();
        const firstRect = first.getBoundingClientRect();
        const lastRect = last.getBoundingClientRect();
        this.previous.disabled = bounds.rtl ? firstRect.right <= bounds.right + 1 : firstRect.left >= bounds.left - 1;
        this.next.disabled = bounds.rtl ? lastRect.left >= bounds.left - 1 : lastRect.right <= bounds.right + 1;
      }

      behavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      move(direction) {
        if (!this.track || !this.hasOverflow()) return;
        const first = this.track.firstElementChild;
        if (!first) return;
        const style = getComputedStyle(this.track);
        const step = first.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
        this.track.scrollBy({ left: direction * (style.direction === 'rtl' ? -1 : 1) * step, behavior: this.behavior() });
      }

      moveToEdge(end) {
        if (!this.track) return;
        const item = end ? this.track.lastElementChild : this.track.firstElementChild;
        if (!item) return;
        const bounds = this.bounds();
        const rect = item.getBoundingClientRect();
        const left = end
          ? (bounds.rtl ? rect.left - bounds.left : rect.right - bounds.right)
          : (bounds.rtl ? rect.right - bounds.right : rect.left - bounds.left);
        this.track.scrollBy({ left, behavior: this.behavior() });
      }
    }
    customElements.define('rw-product-carousel', RunningWomanProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-race-reference-tables"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-race-reference-tables')) customElements.define('rw-race-reference-tables', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = Array.from(this.querySelectorAll('[data-reference-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-reference-panel]'));
      this.onClick = event => {
        const tab = event.target.closest('[data-reference-tab]');
        if (tab && this.tabs.includes(tab)) this.select(tab.dataset.referenceTab);
      };
      this.onKey = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next].dataset.referenceTab);
        this.tabs[next].focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.select(this.dataset.defaultEvent);
      this.querySelector('[role="tablist"]').hidden = false;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.ready = false;
    }
    select(key) {
      if (!this.tabs.some(tab => tab.dataset.referenceTab === key)) return;
      for (const tab of this.tabs) {
        const selected = tab.dataset.referenceTab === key;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      }
      for (const panel of this.panels) {
        panel.hidden = panel.dataset.referencePanel !== key;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.referenceTab === panel.dataset.referencePanel).id);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-race-tools-engine"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('rw-pace-engine').then(() => {
    const pace = customElements.get('rw-pace-engine').math;
    const positive = (value, maximum) => {
      if (!Number.isFinite(value) || value <= 0 || value > maximum) throw new RangeError('Value outside supported range');
      return value;
    };
    const kilometres = (distance, unit) => {
      if (!['km', 'mile'].includes(unit)) throw new RangeError('Unknown distance unit');
      return positive(distance, 1000) * (unit === 'mile' ? pace.mile : 1);
    };
    const date = value => {
      if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new RangeError('Invalid calendar date');
      const [year, month, day] = value.split('-').map(Number);
      if (year < 1900 || year > 2200) throw new RangeError('Date outside supported range');
      const parsed = new Date(Date.UTC(year, month - 1, day));
      if (parsed.getUTCFullYear() !== year || parsed.getUTCMonth() !== month - 1 || parsed.getUTCDate() !== day) throw new RangeError('Invalid calendar date');
      return parsed;
    };
    const iso = value => value.toISOString().slice(0, 10);
    const shift = (value, days) => {
      const next = new Date(value);
      next.setUTCDate(next.getUTCDate() + days);
      return next;
    };
    const math = Object.freeze({
      mile: pace.mile,
      clock: seconds => pace.clock(seconds),
      paceClock: seconds => pace.paceClock(seconds),
      planSelection(search) {
        const params = new URLSearchParams(search);
        const events = {
          mile: { distance: 1, unit: 'mile' },
          '5k': { distance: 5, unit: 'km' },
          '10k': { distance: 10, unit: 'km' },
          '10-mile': { distance: 10, unit: 'mile' },
          half: { distance: 21.0975, unit: 'km' },
          marathon: { distance: 42.195, unit: 'km' },
          'trail-10k': { distance: 10, unit: 'km' },
          'trail-half': { distance: 21.0975, unit: 'km' },
          '50k': { distance: 50, unit: 'km' }
        };
        const requestedDistance = params.getAll('distance');
        const distance = requestedDistance.length === 1 && Object.hasOwn(events, requestedDistance[0]) ? requestedDistance[0] : '';
        const requestedWeeks = params.getAll('weeks');
        const weeks = requestedWeeks.length === 1 && /^\d+$/.test(requestedWeeks[0]) ? Number(requestedWeeks[0]) : NaN;
        return { distance, event: distance ? events[distance] : null, weeks: Number.isInteger(weeks) && weeks >= 1 && weeks <= 52 ? weeks : null };
      },
      todayDate() {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      },
      splits({ distance, unit, time, interval }) {
        const km = kilometres(distance, unit);
        positive(time, 604800);
        if (!['km', 'mile', '5km'].includes(interval)) throw new RangeError('Unknown split interval');
        const step = interval === 'mile' ? pace.mile : interval === '5km' ? 5 : 1;
        const intervalUnit = interval === 'mile' ? 'mile' : 'km';
        const count = Math.floor((km - 1e-9) / step);
        if (count > 1000) throw new RangeError('Too many checkpoints');
        const rows = Array.from({ length: count }, (_, index) => {
          const checkpointKm = (index + 1) * step;
          return { km: checkpointKm, distance: checkpointKm / (intervalUnit === 'mile' ? pace.mile : 1), time: time * checkpointKm / km, finish: false };
        });
        rows.push({ km, distance: km / (intervalUnit === 'mile' ? pace.mile : 1), time, finish: true });
        return { km, time, pace: time / km, rows, intervalUnit };
      },
      runWalk({ distance, unit, runSeconds, walkSeconds, runPace, walkPace, paceUnit }) {
        const km = kilometres(distance, unit);
        if (!['km', 'mile'].includes(paceUnit)) throw new RangeError('Unknown pace unit');
        for (const value of [runSeconds, walkSeconds, runPace, walkPace]) positive(value, 86400);
        const runPerKm = runPace / (paceUnit === 'mile' ? pace.mile : 1);
        const walkPerKm = walkPace / (paceUnit === 'mile' ? pace.mile : 1);
        const runKm = runSeconds / runPerKm;
        const walkKm = walkSeconds / walkPerKm;
        const cycleKm = runKm + walkKm;
        const ratio = km / cycleKm;
        if (!Number.isFinite(ratio) || ratio > 10000000) throw new RangeError('Too many cycles');
        const nearest = Math.round(ratio);
        const completeCycles = Math.abs(ratio - nearest) < 1e-10 ? nearest : Math.floor(ratio);
        const remainder = Math.max(0, km - completeCycles * cycleKm);
        const partialRunTime = Math.min(remainder, runKm) * runPerKm;
        const partialWalkTime = Math.max(0, remainder - runKm) * walkPerKm;
        const runTime = completeCycles * runSeconds + partialRunTime;
        const walkTime = completeCycles * walkSeconds + partialWalkTime;
        const time = runTime + walkTime;
        if (!Number.isFinite(time) || time > 31536000) throw new RangeError('Finish time outside supported range');
        return { km, time, pace: time / km, runTime, walkTime, completeCycles, partialRunTime, partialWalkTime, cycles: completeCycles + (remainder > 1e-9 ? 1 : 0) };
      },
      raceDate({ raceDate, weeks }) {
        if (!Number.isInteger(weeks) || weeks < 1 || weeks > 52) throw new RangeError('Invalid plan length');
        const race = date(raceDate);
        const weekday = race.getUTCDay();
        const finalMonday = shift(race, -((weekday + 6) % 7));
        return { startDate: iso(shift(finalMonday, -7 * (weeks - 1))), raceDate: iso(race), weekEnd: iso(shift(finalMonday, 6)), weekday };
      }
    });
    if (!customElements.get('rw-race-tools-engine')) customElements.define('rw-race-tools-engine', class extends HTMLElement {
      static get math() { return math; }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-race-tools-select"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-race-tools-select')) customElements.define('rw-race-tools-select', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        document.addEventListener('click', this.outside);
        document.addEventListener('focusin', this.focusOutside);
        this.select.form?.addEventListener('reset', this.reset);
        this.observer.observe(this.select, { childList: true, subtree: true, attributes: true, characterData: true });
        this.refresh();
        return;
      }
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.ready = true;
      const label = this.closest('.rw-field')?.querySelector('label');
      const id = this.select.id || `RaceSelect-${Math.random().toString(36).slice(2)}`;
      if (label && !label.id) label.id = `${id}-label`;
      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.id = `${id}-toggle`;
      if (label) label.htmlFor = this.toggle.id;
      this.toggle.className = 'rw-race-select__toggle';
      this.toggle.setAttribute('role', 'combobox');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.setAttribute('aria-haspopup', 'listbox');
      this.toggle.setAttribute('aria-controls', `${id}-options`);
      if (label) this.toggle.setAttribute('aria-labelledby', `${label.id} ${id}-value`);
      this.value = document.createElement('span');
      this.value.id = `${id}-value`;
      this.toggle.append(this.value);
      this.panel = document.createElement('div');
      this.panel.className = 'rw-race-select__panel';
      this.panel.hidden = true;
      this.search = document.createElement('input');
      this.search.type = 'search';
      this.search.autocomplete = 'off';
      this.search.placeholder = this.dataset.searchLabel || '';
      this.search.setAttribute('aria-label', this.dataset.searchLabel || 'Search');
      this.list = document.createElement('div');
      this.list.id = `${id}-options`;
      this.list.className = 'rw-race-select__options';
      this.list.setAttribute('role', 'listbox');
      if (label) this.list.setAttribute('aria-labelledby', label.id);
      this.empty = document.createElement('p');
      this.empty.className = 'rw-race-select__empty';
      this.empty.textContent = this.dataset.emptyLabel || document.querySelector('[data-select-empty]')?.textContent || '';
      this.empty.hidden = true;
      this.panel.append(this.search, this.list, this.empty);
      this.append(this.toggle, this.panel);
      this.select.hidden = true;
      this.refresh = () => {
        this.value.textContent = this.select.selectedOptions[0]?.textContent || '';
        this.toggle.disabled = this.select.disabled;
        this.list.replaceChildren();
        Array.from(this.select.options).forEach(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', String(option.selected));
          button.disabled = option.disabled;
          button.textContent = option.textContent;
          button.dataset.value = option.value;
          button.addEventListener('click', () => {
            this.select.value = option.value;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
            this.close();
            this.toggle.focus();
          });
          this.list.append(button);
        });
        this.filter();
      };
      this.toggle.addEventListener('click', () => this.panel.hidden ? this.open() : this.close());
      this.toggle.addEventListener('keydown', event => {
        if (['ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); this.open(); }
      });
      this.search.addEventListener('input', () => this.filter());
      this.search.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') { event.preventDefault(); this.available()[0]?.focus(); }
        if (event.key === 'Enter') { event.preventDefault(); this.available()[0]?.click(); }
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) { event.preventDefault(); event.stopPropagation(); this.close(); this.toggle.focus(); }
        const choices = this.available();
        const current = choices.indexOf(document.activeElement);
        if (current >= 0 && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : Math.max(0, Math.min(choices.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
          choices[index]?.focus();
        }
      });
      this.outside = event => { if (!this.contains(event.target)) this.close(); };
      this.focusOutside = event => { if (!this.contains(event.target)) this.close(); };
      document.addEventListener('click', this.outside);
      document.addEventListener('focusin', this.focusOutside);
      this.select.addEventListener('change', this.refresh);
      this.reset = () => requestAnimationFrame(() => { this.refresh(); this.close(); });
      this.select.form?.addEventListener('reset', this.reset);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.select, { childList: true, subtree: true, attributes: true, characterData: true });
      this.refresh();
    }
    available() { return Array.from(this.list.querySelectorAll('button')).filter(button => !button.hidden && !button.disabled); }
    filter() {
      const query = this.search.value.trim().toLocaleLowerCase();
      Array.from(this.list.children).forEach(button => { button.hidden = !button.textContent.toLocaleLowerCase().includes(query); });
      this.empty.hidden = this.available().length > 0;
    }
    open() {
      document.querySelectorAll('rw-race-tools-select').forEach(select => { if (select !== this && select.ready) select.close(); });
      this.search.value = '';
      this.filter();
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.search.focus();
    }
    close() { this.panel.hidden = true; this.toggle.setAttribute('aria-expanded', 'false'); }
    disconnectedCallback() {
      document.removeEventListener('click', this.outside);
      document.removeEventListener('focusin', this.focusOutside);
      this.observer?.disconnect();
      this.select?.form?.removeEventListener('reset', this.reset);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-rating-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-rating-summary')) customElements.define('rw-rating-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.trigger = this.querySelector('[data-rating-trigger]');
      this.panel = this.querySelector('[data-rating-popover]');
      if (!this.trigger || !this.panel) return;
      try {
        this.labels = JSON.parse(this.dataset.ratingLabels);
        const summary = JSON.parse(this.dataset.ratingSummary);
        if (this.validSummary(summary)) this.updateSummary(summary);
      } catch { return; }
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const identifier = `RatingBreakdown-${++this.constructor.sequence}`;
      this.panel.id = identifier;
      this.trigger.setAttribute('aria-controls', identifier);
      this.trigger.addEventListener('click', () => {
        if (this.opened && this.pinned) this.close();
        else this.open(true);
      }, options);
      this.trigger.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch' && window.matchMedia('(hover: hover)').matches) this.open(false);
      }, options);
      this.trigger.addEventListener('pointerleave', () => this.scheduleClose(), options);
      this.trigger.addEventListener('focus', () => { if (!this.suppressFocus) this.open(false); }, options);
      this.trigger.addEventListener('blur', () => this.scheduleClose(), options);
      this.panel.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.panel.addEventListener('pointerleave', () => this.scheduleClose(), options);
      this.panel.addEventListener('focusin', () => clearTimeout(this.closeTimer), options);
      this.panel.addEventListener('focusout', () => this.scheduleClose(), options);
      this.panel.querySelector('[data-rating-close]').addEventListener('click', () => {
        this.close();
        this.restoreFocus();
      }, options);
    }
    disconnectedCallback() {
      this.close();
      this.events?.abort();
      this.events = null;
      if (this.panel && this.panel.parentNode !== this) this.append(this.panel);
    }
    validSummary(summary) {
      if (summary?.version !== 1 || !Number.isSafeInteger(summary.count) || summary.count <= 0
        || !Number.isSafeInteger(summary.sum) || summary.sum < summary.count || summary.sum > summary.count * 5
        || typeof summary.average !== 'number' || !Number.isFinite(summary.average)
        || Math.abs(summary.average - summary.sum / summary.count) > 1e-9) return false;
      let count = 0;
      let sum = 0;
      for (let star = 1; star <= 5; star++) {
        const value = summary.distribution?.[star];
        if (!Number.isSafeInteger(value) || value < 0) return false;
        count += value;
        sum += value * star;
      }
      return count === summary.count && sum === summary.sum;
    }
    updateSummary(summary) {
      if (!this.validSummary(summary)) { this.close(); return false; }
      this.summary = summary;
      this.labels ||= JSON.parse(this.dataset.ratingLabels);
      const locale = document.documentElement.lang || 'en-GB';
      const number = value => new Intl.NumberFormat(locale).format(value);
      const rating = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(summary.average);
      const count = number(summary.count);
      const reviews = summary.count === 1 ? this.labels.review : this.labels.reviews;
      const replace = label => label.replaceAll('[rating]', rating).replaceAll('[count]', count);
      this.querySelector('[data-rating-score]')?.replaceChildren(document.createTextNode(rating));
      const countNode = this.querySelector('[data-rating-count]');
      if (countNode) countNode.textContent = this.dataset.context === 'global'
        ? this.labels.from.replaceAll('[count]', count).replaceAll('[reviews]', reviews) : `(${count})`;
      this.querySelector('[data-rating-trigger]')?.setAttribute('aria-label', replace(this.labels.view));
      this.querySelector('[data-rating-stars]')?.setAttribute('aria-label', replace(this.labels.score));
      this.style.setProperty('--rating-fill', `${summary.average * 20}%`);
      const panel = this.panel || this.querySelector('[data-rating-popover]');
      panel.style.setProperty('--rating-fill', `${summary.average * 20}%`);
      panel.querySelector('[data-rating-average]').textContent = rating;
      panel.querySelector('[data-rating-total]').textContent = `${count} ${reviews}`;
      for (let star = 1; star <= 5; star++) {
        const value = summary.distribution[star];
        const row = panel.querySelector(`[data-rating-row="${star}"]`);
        row.querySelector('[data-rating-row-count]').textContent = number(value);
        row.querySelector('[data-rating-bar]').style.width = `${value / summary.count * 100}%`;
        row.setAttribute('aria-label', this.labels.starCount.replaceAll('[rating]', String(star)).replaceAll('[count]', number(value)));
      }
      return true;
    }
    open(pinned) {
      if (!this.summary || !this.panel || !this.isConnected) return;
      clearTimeout(this.closeTimer);
      this.pinned = this.pinned || pinned;
      if (this.opened) return;
      this.constructor.active?.close();
      this.constructor.active = this;
      this.opened = true;
      this.panel.hidden = false;
      try {
        if (typeof this.panel.showPopover !== 'function') throw new Error('Popover fallback');
        this.panel.showPopover();
      } catch {
        this.panel.removeAttribute('popover');
        document.body.append(this.panel);
      }
      this.trigger.setAttribute('aria-expanded', 'true');
      this.position();
      this.openEvents = new AbortController();
      const options = { signal: this.openEvents.signal };
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target) && !this.panel.contains(event.target)) this.close();
      }, { ...options, capture: true });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          const restoreFocus = this.panel.contains(document.activeElement);
          this.close();
          if (restoreFocus) this.restoreFocus();
        }
      }, options);
      window.addEventListener('resize', () => this.position(), options);
      window.addEventListener('scroll', () => this.position(), { ...options, capture: true });
      window.visualViewport?.addEventListener('resize', () => this.position(), options);
      window.visualViewport?.addEventListener('scroll', () => this.position(), options);
    }
    position() {
      if (!this.opened) return;
      const target = this.trigger.getBoundingClientRect();
      const viewport = window.visualViewport;
      const left = viewport?.offsetLeft || 0;
      const top = viewport?.offsetTop || 0;
      const width = viewport?.width || window.innerWidth;
      const height = viewport?.height || window.innerHeight;
      if (target.bottom < top || target.top > top + height || target.right < left || target.left > left + width) { this.close(); return; }
      this.panel.style.maxWidth = `${Math.max(0, width - 24)}px`;
      this.panel.style.maxHeight = `${Math.max(0, height - 24)}px`;
      const bounds = this.panel.getBoundingClientRect();
      const x = Math.max(left + 12, Math.min(target.left, left + width - bounds.width - 12));
      const below = target.bottom + 8;
      const above = target.top - bounds.height - 8;
      const y = below + bounds.height <= top + height - 12 ? below : Math.max(top + 12, above);
      this.panel.style.left = `${Math.round(x)}px`;
      this.panel.style.top = `${Math.round(y)}px`;
    }
    scheduleClose() {
      clearTimeout(this.closeTimer);
      if (this.pinned) return;
      this.closeTimer = setTimeout(() => {
        if (this.trigger === document.activeElement || this.panel.contains(document.activeElement)) return;
        this.close();
      }, 180);
    }
    restoreFocus() {
      this.suppressFocus = true;
      this.trigger.focus({ preventScroll: true });
      this.suppressFocus = false;
    }
    close() {
      clearTimeout(this.closeTimer);
      this.openEvents?.abort();
      this.openEvents = null;
      this.pinned = false;
      this.opened = false;
      if (this.constructor.active === this) this.constructor.active = null;
      if (this.panel) {
        try { this.panel.hidePopover?.(); } catch { /* The panel may already have left the top layer. */ }
        this.panel.hidden = true;
      }
      this.trigger?.setAttribute('aria-expanded', 'false');
    }
    static sequence = 0;
    static active = null;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-responsive-tables"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-responsive-tables')) {
    customElements.define('rw-responsive-tables', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }

      initialize() {
        if (!this.states) {
          this.states = [];
          const controlsTemplate = this.querySelector('[data-table-controls]');
          this.querySelectorAll('.rw-prose table').forEach((table, index) => {
            if (table.closest('.rw-table-scroll')) return;
            const frame = document.createElement('div');
            frame.className = 'rw-table-frame';
            const controls = controlsTemplate.content.firstElementChild.cloneNode(true);
            const scroll = document.createElement('div');
            scroll.className = 'rw-table-scroll';
            scroll.id = this.id + '-table-' + index;
            scroll.tabIndex = 0;
            scroll.setAttribute('role', 'region');
            scroll.setAttribute('aria-label', table.caption?.textContent.trim() || this.dataset.tableLabel.replace('[number]', index + 1));
            table.before(frame);
            frame.append(controls, scroll);
            scroll.append(table);

            if (table.tHead) {
              table.tHead.querySelectorAll('th:not([scope])').forEach(cell => cell.scope = 'col');
            }
            if (table.classList.contains('paceTables')) {
              table.querySelectorAll('tr').forEach(row => {
                const cell = row.cells[0];
                if (!cell || cell.colSpan !== 1 || cell.rowSpan !== 1) return;
                if (cell.tagName === 'TD' && !row.closest('thead')) {
                  const heading = document.createElement('th');
                  [...cell.attributes].forEach(attribute => heading.setAttribute(attribute.name, attribute.value));
                  heading.scope = 'row';
                  heading.append(...cell.childNodes);
                  cell.replaceWith(heading);
                  heading.dataset.stickyPace = '';
                } else {
                  cell.dataset.stickyPace = '';
                }
              });
            }

            const buttons = [...controls.querySelectorAll('button')];
            const state = { scroll, controls, buttons };
            buttons.forEach(button => {
              button.setAttribute('aria-controls', scroll.id);
              button.addEventListener('click', () => {
                const direction = getComputedStyle(scroll).direction === 'rtl' ? -1 : 1;
                scroll.scrollBy({
                  left: Number(button.dataset.tableDirection) * direction * scroll.clientWidth * .8,
                  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
                });
              });
            });
            scroll.addEventListener('scroll', () => this.update(state), { passive: true });
            this.states.push(state);
          });
          this.dataset.enhanced = '';
          this.removeAttribute('tabindex');
          this.removeAttribute('role');
          this.removeAttribute('aria-label');
        }
        this.observer = new ResizeObserver(() => this.states.forEach(state => this.update(state)));
        this.states.forEach(state => {
          this.observer.observe(state.scroll);
          this.observer.observe(state.scroll.querySelector('table'));
          this.update(state);
        });
      }

      update({ scroll, controls, buttons }) {
        const maximum = scroll.scrollWidth - scroll.clientWidth;
        const position = Math.abs(scroll.scrollLeft);
        controls.hidden = maximum <= 1;
        buttons[0].disabled = position <= 1;
        buttons[1].disabled = position >= maximum - 1;
        scroll.toggleAttribute('data-scrolled', position > 1);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-review-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-review-summary')) customElements.define('rw-review-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.source === 'shopify') {
        if (this.dataset.nativeEnabled !== 'true') { this.hidden = true; return; }
        try {
          const summary = JSON.parse(this.querySelector('[data-review-summary-native]').textContent);
          if (!this.validNativeSummary(summary)) throw new Error('Invalid Shopify review summary.');
          this.renderSummary(summary);
        } catch { this.hidden = true; }
        return;
      }
      if (this.controller) return;
      this.controller = new AbortController();
      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      Promise.resolve().then(() => {
        const url = new URL(`${this.dataset.apiBase.replace(/\/$/, '')}/api/reviews/summary`, location.origin);
        if (!['http:', 'https:'].includes(url.protocol) || url.origin !== location.origin || url.username || url.password) throw new Error('Review summary endpoint must be same-origin.');
        return fetch(url, { credentials: 'same-origin', signal: controller.signal });
      }).then(response => {
        if (!response.ok) throw new Error('Review summary unavailable.');
        return response.json();
      }).then(result => {
        if (!this.isConnected || controller.signal.aborted) return;
        this.renderSummary(result.summary);
      }).catch(() => { this.hidden = true; }).finally(() => {
        clearTimeout(timeout);
        if (this.controller === controller) this.controller = null;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    renderSummary(summary) {
      const count = Number(summary?.count);
      const average = Number(summary?.average);
      if (!Number.isSafeInteger(count) || count <= 0 || !Number.isFinite(average) || average < 1 || average > 5) {
        this.hidden = true;
        return;
      }
      const labels = JSON.parse(this.querySelector('[data-review-summary-labels]').textContent);
      const locale = document.documentElement.lang || 'en-GB';
      const rating = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(average);
      const formattedCount = new Intl.NumberFormat(locale).format(count);
      this.querySelector('[data-review-summary-score]').textContent = `${rating} / 5`;
      this.querySelector('[data-review-summary-count]').textContent = labels.from.replaceAll('[count]', formattedCount).replaceAll('[reviews]', count === 1 ? labels.review : labels.reviews);
      this.style.setProperty('--review-summary-fill', `${average / 5 * 100}%`);
      const accessibleScore = labels.score.replaceAll('[rating]', rating).replaceAll('[count]', formattedCount);
      this.querySelector('[data-review-summary-stars]').setAttribute('aria-label', accessibleScore);
      const breakdown = { version: 1, count: summary.count, sum: summary.sum, average: summary.average, distribution: {} };
      for (let star = 1; star <= 5; star++) breakdown.distribution[star] = summary.distribution?.[star];
      const compact = this.querySelector('rw-rating-summary');
      if (compact && this.validNativeSummary(breakdown)) {
        compact.dataset.ratingSummary = JSON.stringify(breakdown);
        compact.updateSummary?.(breakdown);
      }
      this.hidden = false;
    }
    validNativeSummary(summary) {
      if (summary?.version !== 1 || !Number.isSafeInteger(summary.count) || summary.count <= 0
        || !Number.isSafeInteger(summary.sum) || summary.sum < summary.count || summary.sum > summary.count * 5
        || typeof summary.average !== 'number' || !Number.isFinite(summary.average)
        || Math.abs(summary.average - summary.sum / summary.count) > 1e-9) return false;
      let count = 0;
      let sum = 0;
      for (let star = 1; star <= 5; star++) {
        const value = summary.distribution?.[star];
        if (!Number.isSafeInteger(value) || value < 0) return false;
        count += value;
        sum += value * star;
      }
      return count === summary.count && sum === summary.sum;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-session-visual"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-session-visual')) {
    customElements.define('rw-session-visual', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.phases = Array.from(this.querySelectorAll('[data-session-phase]'));
        this.status = this.querySelector('[data-session-phase-status]');
        if (!this.phases.length || !this.status) return;
        this.initialized = true;
        this.setAttribute('data-enhanced', '');
        this.phases.forEach((phase, index) => {
          phase.setAttribute('tabindex', index === 0 ? '0' : '-1');
          phase.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.show(phase); });
          phase.addEventListener('pointerleave', () => this.restore());
          phase.addEventListener('focus', () => { this.selected = phase; this.show(phase); });
          phase.addEventListener('click', () => { this.pinned = true; this.select(index); });
          phase.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = Math.min(index + 1, this.phases.length - 1);
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = Math.max(index - 1, 0);
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.phases.length - 1;
            else if (event.key === 'Escape') { event.preventDefault(); this.hide(); return; }
            else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.pinned = true; this.show(phase); return; }
            else return;
            event.preventDefault();
            this.select(next);
          });
        });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.hide(); });
        this.addEventListener('pointerleave', () => this.restore());
      }
      select(index) {
        this.phases.forEach((phase, i) => phase.setAttribute('tabindex', i === index ? '0' : '-1'));
        this.selected = this.phases[index];
        this.selected.focus({ preventScroll: true });
        this.show(this.selected);
      }
      show(phase) {
        this.dismissed = false;
        this.phases.forEach(item => { if (item === phase) item.setAttribute('data-active', ''); else item.removeAttribute('data-active'); });
        this.status.textContent = phase.getAttribute('aria-label');
      }
      restore() {
        if (this.dismissed) return;
        const focused = this.phases.find(phase => phase === document.activeElement);
        if (this.pinned && this.selected) this.show(this.selected);
        else if (focused) this.show(focused);
        else this.hide();
      }
      hide() {
        this.pinned = false;
        this.dismissed = true;
        this.phases.forEach(phase => phase.removeAttribute('data-active'));
        this.status.textContent = '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rw-story-form-enhancement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rw-story-form-enhancement')) customElements.define('rw-story-form-enhancement', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.scope = this.closest('rw-story-form');
      if (!this.scope || this.scope.dataset.formId !== this.dataset.formId || !/^[1-9]\d*$/.test(this.dataset.formId || '')) return;
      this.fields = [...(this.querySelector('[data-rw-story-fields]')?.content.children || [])];
      if (this.fields.length !== 28) return;
      this.roots = new Map();
      this.attempts = 0;
      this.active = true;
      this.scopeObserver = new MutationObserver(() => this.discover());
      this.scopeObserver.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-forms-id', 'data-form-id'] });
      customElements.whenDefined('shopify-forms-embed').then(() => { if (this.active && this.isConnected) this.discover(); });
      this.discover();
    }
    disconnectedCallback() { this.stop(); }
    eligibleHost(host) {
      if (this.closest('rw-story-form') !== this.scope || this.scope.dataset.formId !== this.dataset.formId) return false;
      if (host.closest('rw-story-form') !== this.scope) return false;
      const ancestor = host.closest('[data-forms-id]');
      const id = host.getAttribute('data-forms-id') || (ancestor && this.scope.contains(ancestor) ? ancestor.getAttribute('data-forms-id') : null);
      return id === this.dataset.formId || id === `forms-root-${this.dataset.formId}`;
    }
    discover() {
      if (!this.active || !this.isConnected) return;
      if (this.closest('rw-story-form') !== this.scope || this.scope.dataset.formId !== this.dataset.formId || !/^[1-9]\d*$/.test(this.dataset.formId || '')) {
        for (const state of this.roots.values()) this.release(state);
        this.roots.clear();
        window.clearInterval(this.timer); this.timer = undefined;
        return;
      }
      const active = new Set();
      let waiting = false;
      for (const host of this.scope.querySelectorAll('shopify-forms-embed')) {
        if (!this.eligibleHost(host)) continue;
        const root = host.shadowRoot;
        if (!root) { waiting = true; continue; }
        active.add(root);
        let state = this.roots.get(root);
        if (!state) {
          state = { host, nodes: [], attributes: new Map() };
          state.observer = new MutationObserver(() => this.enhance(root, state));
          state.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['id', 'name', 'aria-describedby'] });
          this.roots.set(root, state);
        }
        this.enhance(root, state);
      }
      for (const [root, state] of this.roots) if (!active.has(root)) { this.release(state); this.roots.delete(root); }
      if (waiting && this.timer === undefined && this.attempts < 120) this.timer = window.setInterval(() => { this.attempts++; this.discover(); }, 500);
      if (!waiting || this.attempts >= 120) { window.clearInterval(this.timer); this.timer = undefined; }
    }
    inspect(root) {
      const forms = root.querySelectorAll('form[data-testid="form"]');
      if (forms.length !== 1) return null;
      const form = forms[0];
      const button = form.querySelector('button[type="submit"][data-testid="btn-form-submit"]');
      if (!button || button.parentElement !== form) return null;
      const matches = [];
      for (const field of this.fields) {
        const key = field.dataset.key;
        if (!/^[a-z_]+$/.test(key)) return null;
        const name = key === 'email' ? 'email' : `custom#${key}`;
        const candidates = form.querySelectorAll(`[id="${name}"], textarea[name="${name}"], fieldset[name="${name}"], [id="${name}-selector-label"], input[id="${name}-field"]`);
        if (candidates.length !== 1) return null;
        const control = candidates[0];
        let wrapper = control;
        while (wrapper.parentElement && wrapper.parentElement !== form) wrapper = wrapper.parentElement;
        if (wrapper.parentElement !== form || wrapper === button || matches.some(match => match.wrapper === wrapper)) return null;
        matches.push({ field, control, wrapper, name });
      }
      return { form, matches };
    }
    attribute(state, element, key, value) {
      let attributes = state.attributes.get(element);
      if (!attributes) { attributes = new Map(); state.attributes.set(element, attributes); }
      const current = element.getAttribute(key);
      let record = attributes.get(key);
      if (!record) { record = { original: current, applied: value, added: new Set() }; attributes.set(key, record); }
      if (key === 'aria-describedby') {
        const existing = new Set((current || '').split(/\s+/).filter(Boolean));
        for (const token of value.split(/\s+/).filter(Boolean)) if (!existing.has(token)) record.added.add(token);
      }
      record.applied = value;
      if (current !== value) element.setAttribute(key, value);
    }
    enhance(root, state) {
      if (!this.active || state.enhancing) return;
      state.enhancing = true;
      try {
        if (!this.eligibleHost(state.host) || state.host.shadowRoot !== root) { this.restore(state); return; }
        const match = this.inspect(root);
        if (!match) { this.restore(state); return; }
        if (state.form !== match.form || !state.style?.isConnected || state.nodes.some(node => !node.isConnected) || match.matches.some((item, index) => item.wrapper !== state.matches?.[index]?.wrapper || item.control !== state.matches?.[index]?.control)) {
          this.restore(state);
          state.form = match.form;
          state.matches = match.matches;
          const style = this.querySelector('[data-rw-story-style]')?.content.querySelector('style');
          if (!style) return;
          state.style = style.cloneNode(true);
          root.append(state.style);
          this.attribute(state, match.form, 'data-rw-story-form', '');
          const container = match.form.closest('section');
          if (container) this.attribute(state, container, 'data-rw-story-container', '');
          const header = match.form.previousElementSibling;
          if (header?.tagName === 'SECTION' && header.querySelector('h2')) this.attribute(state, header, 'data-rw-story-header', '');
          // Only add presentation siblings; never move or replace Shopify-controlled fields.
          for (const { field, control, wrapper, name } of match.matches) {
            this.attribute(state, wrapper, 'data-rw-story-field', field.dataset.key);
            for (const [flag, attribute] of [['compact', 'data-rw-story-compact'], ['signature', 'data-rw-story-signature']]) if (field.hasAttribute(`data-${flag}`)) this.attribute(state, wrapper, attribute, '');
            const heading = field.querySelector('h2');
            if (heading) { const node = heading.cloneNode(true); node.dataset.rwStoryHeading = field.dataset.group; wrapper.before(node); state.nodes.push(node); }
            const label = wrapper.querySelector('label[for]');
            if (control.tagName === 'TEXTAREA' && !control.id && label?.getAttribute('for') === name) this.attribute(state, control, 'id', name);
            if (field.hasAttribute('data-required')) {
              this.attribute(state, control, 'aria-required', 'true');
              const original = this.querySelector('template[data-rw-story-required]')?.content.querySelector('span');
              if (original && label) { const node = original.cloneNode(true); label.append(node); state.nodes.push(node); }
            }
            const helper = field.querySelector('p');
            if (helper) {
              const node = helper.cloneNode(true);
              node.dataset.rwStoryHelper = '';
              node.id = `rw-story-help-${this.dataset.formId}-${field.dataset.key}`;
              wrapper.append(node);
              state.nodes.push(node);
              const target = control.tagName === 'P' ? wrapper.querySelector('button') : control;
              if (target) {
                if (!state.descriptions) state.descriptions = new Map();
                state.descriptions.set(target, node.id);
              }
            }
          }
        }
        for (const [target, helperId] of state.descriptions || []) this.attribute(state, target, 'aria-describedby', [...new Set([...(target.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean), helperId])].join(' '));
      } finally { state.enhancing = false; }
    }
    restore(state) {
      for (const node of state.nodes || []) node.remove();
      state.style?.remove();
      for (const [element, attributes] of state.attributes || []) for (const [key, record] of attributes) {
        const current = element.getAttribute(key);
        if (key === 'aria-describedby') {
          if (current === null) continue;
          // Remove our helper references without losing later native validation messages.
          const retained = current.split(/\s+/).filter(token => token && !record.added.has(token));
          if (retained.length) element.setAttribute(key, retained.join(' '));
          else if (record.original === '') element.setAttribute(key, '');
          else element.removeAttribute(key);
        } else if (current === record.applied) {
          if (record.original === null) element.removeAttribute(key); else element.setAttribute(key, record.original);
        }
      }
      state.attributes?.clear();
      state.descriptions?.clear();
      state.nodes = []; state.style = null; state.form = null; state.matches = null;
    }
    release(state) { state.observer.disconnect(); this.restore(state); }
    stop() {
      this.active = false;
      window.clearInterval(this.timer); this.timer = undefined;
      this.scopeObserver?.disconnect();
      for (const state of this.roots?.values() || []) this.release(state);
      this.roots?.clear();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
